var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "url(#paint0_linear_549_10013)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3986 25.5731C23.0809 25.1806 23.9582 25.1806 24.738 25.5731L30.1967 28.8111L33.9008 30.8716L39.262 34.1096C39.9443 34.5021 40.8216 34.5021 41.6014 34.1096L45.7929 31.5585C46.4752 31.166 46.9626 30.381 46.9626 29.4979V24.5919C46.9626 23.8069 46.5727 23.022 45.7929 22.5314L41.6014 20.0783C40.9191 19.6859 40.0418 19.6859 39.262 20.0783L35.0705 22.6295C34.3882 23.022 33.9008 23.8069 33.9008 24.69V27.928L30.1967 25.7693V22.4332C30.1967 21.6483 30.5866 20.8633 31.3664 20.3727L39.1645 15.761C39.8468 15.3686 40.7241 15.3686 41.5039 15.761L49.497 20.4708C50.2768 20.8633 50.6667 21.6483 50.6667 22.4332V31.6566C50.6667 32.4416 50.2768 33.2265 49.497 33.7171L41.6014 38.3288C40.9191 38.7213 40.0418 38.7213 39.262 38.3288L33.9008 35.1889L30.1967 33.0303L24.8355 29.8904C24.1532 29.4979 23.2759 29.4979 22.4961 29.8904L18.3046 32.3434C17.6223 32.7359 17.1349 33.5209 17.1349 34.404V39.31C17.1349 40.095 17.5248 40.8799 18.3046 41.3705L22.3986 43.8236C23.0809 44.216 23.9582 44.216 24.738 43.8236L28.9295 41.3705C29.6118 40.9781 30.0992 40.1931 30.0992 39.31V36.1701L33.8033 38.3288V41.5668C33.8033 42.3517 33.4134 43.1367 32.6336 43.6273L24.738 48.239C24.0557 48.6315 23.1784 48.6315 22.3986 48.239L14.5031 43.6273C13.8207 43.2348 13.3333 42.4499 13.3333 41.5668V32.2453C13.3333 31.4603 13.7232 30.6754 14.5031 30.1848L22.3986 25.5731Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_549_10013",
    x1: 9.5,
    y1: 10,
    x2: 54,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9630CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3EE3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatic);
export default __webpack_public_path__ + "static/media/MATIC.f9208d1fa385c857ec163fab7e841b5e.svg";
export { ForwardRef as ReactComponent };